import { EventBus } from "@/internal";
import { AxiosError } from "axios";
import forOwn from "lodash/forOwn";
import isArray from "lodash/isArray";
import reduce from "lodash/reduce";

export interface WeedMapsError {
  success: boolean;
  error: string;
  error_description: { errors: ErrorDetail[] };
  code: number;
}
interface ErrorDetail {
  code: string;
  detail: string;
  status: string;
  title: string;
}

const getLastNested = (obj: any, stringsArr: string[] = []) => {
  forOwn(obj, (value, key) => {
    if (typeof value === "string") {
      stringsArr.push(value);
    } else {
      getLastNested(value, stringsArr);
    }
  });
  return stringsArr;
};

const parseWeedmapsError = (resp: WeedMapsError): string[] => {
  if (resp.error_description && resp.error_description.errors.length) {
    return resp.error_description.errors.map(e => e.detail);
  }
  if (resp.error) {
    return [resp.error];
  }
  return [];
};

class MessagesService {
  public flatErrors(errorsObj: any) {
    return reduce(
      errorsObj,
      (acc: string[], field, key) => {
        if (key !== "exception") {
          if (isArray(field)) {
            acc = [...acc, ...field];
          } else {
            acc = [...acc, ...getLastNested(field)];
          }
        }
        return acc;
      },
      []
    );
  }

  public renderErrorMessage(e: AxiosError) {
    const errorResp: ErrorApiResponse = e.response && e.response.data;
    if (
      errorResp &&
      errorResp.error &&
      typeof errorResp.error!.errors === "object"
    ) {
      const errors = this.flatErrors(errorResp.error!.errors);
      this.showMessage(
        "fas fa-exclamation-circle",
        errors.length ? errors : "server_error",
        "error"
      );
    } else {
      const message =
        (errorResp && errorResp.error && errorResp.error!.message) ||
        e.toString();
      this.showMessage("fas fa-exclamation-circle", message, "error");
    }
  }

  public renderSuccessMessage(message: string | string[]) {
    this.showMessage("fas fa-check-circle", message, "success");
  }

  public renderWarningMessage(message: string | string[]) {
    this.showMessage("fas fa-exclamation-circle", message, "warning");
  }

  public renderWMErrorMessage(e: AxiosError) {
    const messages = parseWeedmapsError((e.response!
      .data as unknown) as WeedMapsError);
    if (messages.length) {
      this.showMessage("fas fa-exclamation-circle", messages, "error");
    }
  }

  public showMessage(
    icon: string,
    text: string | string[],
    color: string,
    x: string = "",
    y: string = "top"
  ) {
    EventBus.$emit("notify", {
      icon,
      text,
      color,
      x,
      y
    });
  }
}

export const messagesService: MessagesService = new MessagesService();

export interface ErrorApiResponse {
  status: string;
  error?: {
    message: string;
    errors: {
      data: any;
    };
    code: number;
  };
}
